export default __webpack_public_path__ + "static/media/tosca_new.0c1656c2.png";